/**
 * @generated SignedSource<<25405010d22f2f00aea68d675a392515>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RevokeAddedClientInput = {
  clientMutationId?: string | null | undefined;
  id: string;
};
export type PendingInviteItemDeleteMutation$variables = {
  input: RevokeAddedClientInput;
};
export type PendingInviteItemDeleteMutation$data = {
  readonly revokeAddedClient: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type PendingInviteItemDeleteMutation = {
  response: PendingInviteItemDeleteMutation$data;
  variables: PendingInviteItemDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RevokeAddedClientPayload",
    "kind": "LinkedField",
    "name": "revokeAddedClient",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PendingInviteItemDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PendingInviteItemDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a1ec6fabb29f18f3be1218c3b4daac14",
    "id": null,
    "metadata": {},
    "name": "PendingInviteItemDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation PendingInviteItemDeleteMutation(\n  $input: RevokeAddedClientInput!\n) {\n  revokeAddedClient(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "356e3d31349b18f7170b686bad538887";

export default node;
